<template>
    <v-container>
        <v-row>

            <v-col cols="12" md="6" offset-md="3" v-if="loading">
                <v-progress-linear v-if="loading" color="primary" indeterminate></v-progress-linear>
            </v-col>

            <v-col cols="12" md="6" offset-md="3">

                <v-row>
                    <v-col cols="12">
                        <v-select
                            :items="activeRooms"
                            item-text="Text"
                            item-value="RoomID"
                            v-model="selectedRoom"
                            return-object
                            label="Room"
                            :disabled="(numberOfSpecimensFound && numberOfSpecimensFound > 0) || loading || saving"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="selectedRackNumber"
                            label="Rack Number"
                            counter="200"
                            maxlength="200"
                            :disabled="(numberOfSpecimensFound && numberOfSpecimensFound > 0) || loading || saving"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="numberOfSpecimensFound === 0 || (numberOfSpecimensFound && numberOfSpecimensFound > 0)">
                        Found {{numberOfSpecimensFound}} specimen(s) in the selected Room and Rack:
                        <ul>
                            <li v-for="specimen in specimensFound" :key="specimen.SpecimenID">
                                {{specimen.SpecimenDisplayID}} - {{specimen.RackNumber}}
                            </li>
                        </ul>
                    </v-col>
                    <v-col cols="12">
                        <v-select
                            v-if="numberOfSpecimensFound && numberOfSpecimensFound > 0"
                            :items="activeRooms"
                            item-text="Text"
                            item-value="RoomID"
                            v-model="selectedNewRoom"
                            return-object
                            label="New Room"
                            :disabled="saving || loading"
                        ></v-select>
                    </v-col>
                </v-row>
                
                <v-row class="dialog-action-buttons">
                    <v-col cols="6">
                        <v-btn
                            block
                            color="error"
                            :disabled="saving || loading"
                            @click="reset"
                        >
                            Reset
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn
                            v-if="numberOfSpecimensFound && numberOfSpecimensFound > 0"
                            block
                            color="success"
                            :loading="saving || loading"
                            :disabled="!(selectedNewRoom && selectedNewRoom.RoomID > 0) || (selectedNewRoom.RoomID === selectedRoom.RoomID)"
                            @click="save"
                        >
                            Save
                        </v-btn>
                        <v-btn
                            v-else
                            block
                            color="success"
                            :loading="saving || loading"
                            @click="findSpecimens"
                            :disabled="!selectedRoom || !selectedRackNumber"
                        >
                            Find Specimens
                        </v-btn>
                    </v-col>
                    <v-col cols="12" v-if="error">
                        <v-alert text type="error">{{ error }}</v-alert>
                    </v-col>
                </v-row>

            </v-col>

        </v-row>

        <v-dialog v-model="showConfirmDialog" persistent max-width="600">
            <v-card class="confirm-dialog">
                <v-card-title class="headline">Confirm Move Rack</v-card-title>
                <v-card-text>Are you sure you wish to move all specimens in rack <span class="highlight-data">{{selectedRackNumber}}</span> from room <span class="highlight-data">{{selectedRoom ? selectedRoom.Text : ""}}</span> to room <span class="highlight-data">{{selectedNewRoom ? selectedNewRoom.Text : ""}}</span>?</v-card-text>
                <v-card-text>This action cannot be undone.</v-card-text>
                <v-card-actions>
                    <v-row >
                        <v-col cols="6">
                            <v-btn color="error" block @click="cancel()">Cancel</v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn color="success" block @click="confirm()">Move Rack</v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<style scoped>
    #app .highlight-data {
        font-weight: bold;
    }
</style>

<script>
import util from '@/helpers/util';
import constants from 'comunet-btg-utah-repository-shared/constants';
import moment from 'moment';
import { mapGetters } from 'vuex';
import api from '@/services/api';

export default {
    components: {
        
    },
    props: [
        
    ],
    data() {
        return {
            saving: false,
            error: null,
            selectedRoom: null,
            selectedRackNumber: "",
            selectedNewRoom: null,
            specimensFound: null,
            specimensLoading: false,
            showConfirmDialog: false
        };
    },
    computed: {
        ...mapGetters({
            activeRooms: "locationStore/activeRooms",
            locationsLoading: "locationStore/loading"
        }),
        canSave() {
            return false;
        },
        loading() {
            return this.locationsLoading || this.specimensLoading;
        },
        numberOfSpecimensFound() {
            if (!this.specimensFound) {
                return null;
            }

            return this.specimensFound.length;
        }
    },
    methods: {
        selectedRoomChanged(room) {
            this.selectedRoom = room;
        },
        selectedNewRoomChanged(room) {
            this.selectedNewRoom = room;
        },
        reset() {
            this.selectedRoom = null;
            this.selectedRackNumber = "";
            this.selectedNewRoom = null;
            this.specimensFound = null;
            this.error = null;
        },
        cancel() {
            this.showConfirmDialog = false;
        },
        save() {
            this.showConfirmDialog = true;
        },
        async confirm() {
            this.showConfirmDialog = false;

            try {
                this.saving = true;
                this.error = null;

                let data = await api.moveSpecimensInRoomAndRack({
                    RoomID: this.selectedRoom.RoomID,
                    RackNumber: this.selectedRackNumber,
                    NewRoomID: this.selectedNewRoom.RoomID,
                    Date: moment().format(constants.MYSQL_DATE_FORMAT)
                });

                this.reset();
            }
            catch (e) {
                this.error = e;
            }
            finally {
                this.saving = false;
            }
        },
        async findSpecimens() {
            try {
                this.specimensLoading = true;
                this.error = null;
                this.specimensFound = null;

                let data = await api.fetchSpecimensInRoomAndRack({
                    RoomID: this.selectedRoom.RoomID,
                    RackNumber: this.selectedRackNumber
                });

                this.specimensFound = data;
            }
            catch (e) {
                this.error = e;
            }
            finally {
                this.specimensLoading = false;
            }
        }
    },
    created() {
        Promise.all([
            this.$store.dispatch("locationStore/loadRooms")
        ]);
    }
};
</script>